import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

export const getSMSApiKeys = async (client_id: string): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;

    const uri = `${config.uri.base_url}/clients/${client_id}/sms-api-keys`;
    const options = {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };
    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Failed to fetch SMS API keys');
    }

    const keys = Array.isArray(result.keys) ? result.keys : [''];
    if (keys.length === 1) {
      keys.push('');
    }

    return { keys };
  } catch (err) {
    console.error(`Error fetching API keys for client ${client_id}:`, err);
    throw err;
  }
};
